import React from "react";

export default function ByIngredients({ recipe, ingredients }) {
	const allIngredients = recipe.recipeIngredientGroups
		.flatMap((group) => group.recipeIngredients)
		.map((el) => el.ingredient?.name);

	const set = new Set(ingredients);
	const has = [];
	const notHas = [];

	for (let ingredient of allIngredients) {
		set.has(ingredient) ? has.push(ingredient) : notHas.push(ingredient);
	}

	return (
		<div className="card" style={{ marginBottom: "1rem" }}>
			{recipe?.photo?.imageUrl ? (
				<div
					className="card-image"
					style={{
						backgroundImage: `url(${recipe.photo?.imageUrl}), linear-gradient(141deg, rgb(210, 210, 210) 0px, rgb(100, 100, 100) 100%)`,
						backgroundSize: "cover",
					}}></div>
			) : null}
			<div className="card-content">
				<div className="media-content">
					<p className="title is-6">{recipe.title}</p>
				</div>
				<div>
					<p className="is-7">You Have</p>
					<div className="tags">
						{has.map((el, i) => (
							<div className="tag is-success is-light" key={i}>
								{el}
							</div>
						))}
					</div>
				</div>
				<div>
					<p className="is-7">You Need</p>
					<div className="tags">
						{notHas.map((el, i) => (
							<div className="tag is-danger is-light" key={i}>
								{el}
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
